import * as types from '../types';

import moment from 'moment';
import update from 'immutability-helper';
import {
    VIEW_MODE,
    EDIT_MODE,
} from '@Utils/constants';

const initialTitle = 'Onboarding Training';

export const initialDetailForm = {
    onboardingTrainingID: '',
    trainingMasterModuleID: 0,
    trainingCategoryID: 0,
    trainingCategory: '',
    trainingName: '',
    facilitator: 0,
    facilitatorName: '',
    startTrainingDate: moment().format('MM/DD/YYYY HH:mm'),
    endTrainingDate: moment().format('MM/DD/YYYY HH:mm'),
    status: 0,
    onboardingType: 0,
    createDate: moment().format('MM/DD/YYYY HH:mm'),
    createdBy: 0,
    auditTrail: [],
}


const defaultState = {
    title: 'Onboarding Training',
    mode: VIEW_MODE,
    loading: true,
    hasLoadedData: false,
    isEditable: false,
    detailForm: { ...initialDetailForm },
    emailTemplate: { subject: '', body: '' },
    curriculumVitae: [],
    alert: {
        show: false,
        title: 'Update Success',
        content: 'Successfully updated record',
        confirmLabel: 'Ok',
        goBacktoListFlag: false,
        onHide: () => { },
    },
};

export default function detailReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_DETAIL_DATA:
            return update(state, {
                detailForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.UPD_DETAIL_TITLE:
            return update(state, {
                title: { $set: action.payload }
            });
        case types.UPD_DETAIL_MODE:
            return update(state, {
                mode: { $set: action.payload }
            });
        case types.HAS_DETAIL_LOADED:
            return update(state, {
                hasLoadedData: { $set: action.payload }
            });
        case types.SET_DETAIL_DATA:
            let data = action.payload;
            let initialMode = action.mode === 'view' ? VIEW_MODE : EDIT_MODE;
            let editable = initialMode === EDIT_MODE ? true : false;
            return update(state, {
                title: { $set: initialTitle },
                mode: { $set: initialMode },
                isEditable: { $set: editable },
                detailForm: { $set: data },
                alert: { $set: defaultState.alert },

            });
        case types.RESET_DETAIL_DATA:
            return update(state, {
                detailForm: {
                    onboardingTrainingID: { $set: 0 },
                    facilitator: { $set: 0 },
                    startTrainingDate: { $set: moment().format('MM/DD/YYYY HH:mm') },
                    endTrainingDate: { $set: moment().format('MM/DD/YYYY HH:mm') },
                    onboardingType: { $set: 0 },
                    trainingCategory: { $set: 0 },
                    trainingMasterModuleID: { $set: '' },
                    CreatedDate: { $set: moment().format('MM/DD/YYYY HH:mm') },
                    CreatedBy: { $set: 0 },
                }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.HIDE_DETAIL_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SET_DETAIL_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.SET_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: { $set: action.payload }
            });
        case types.HIDE_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: false }
                }
            });
        case types.SHOW_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: true }
                }
            });
        case types.SET_EDITABLE:
            return {
                ...state,
                isEditable: action.payload,
            };
        case types.SET_PARTICIPANT_DATA:
            return {
                ...state,
                participants: action.payload,
            };
        case types.SET_DETAIL_EMAIL_TEMPLATE:
                return update(state, {
                    emailTemplate: { $set: action.payload }
                });    
        default:
            return state;
    }
}
